export const ADD_CASE_SUCCESS_MESSAGE = 'Case scheduled successfully!';
export const UPDATE_CASE_SUCCESS_MESSAGE = 'Case updated successfully!';
export const APPROVE_CASE_SUCCESS_MESSAGE = 'Case is successfully approved!';
export const REJECT_CASE_SUCCESS_MESSAGE = 'Case is successfully rejected.';
export const DELETE_CASE_SUCCESS_MESSAGE = 'Case deleted successfully!';
export const DELETE_CASE_ERROR_MESSAGE = 'Something went wrong during case deletion.';
export const SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE = 'Pickup scheduled.';
export const CANCEL_PICKUP_CASE_SUCCESS_MESSAGE = 'Pickup canceled.';
export const CONVERT_TO_SUBCASE_SUCCESS_MESSAGE = 'Case is successfully converted to subcase.';
export const CONVERT_TO_CASE_SUCCESS_MESSAGE = 'Subcase is successfully converted to case.';


// WEBPACK FOOTER //
// ./src/shared/constants/toasterMessages.js